export const BasicAlertSubTitle = [{ text: "Print the basic message." }];

export const TitleWithTextSubTitle = [{ text: "Print the title with text." }];

export const InfoAlertSubTitle = [{ text: "Print the informational message." }];

export const WarningAlertSubTitle = [{ text: "Warning for imaginary files." }];

export const PikachuAlertSubTitle = [{ text: "catch the pokeball." }];

export const QuestionAlertSubTitle = [{ text: "Print the questionary and give answers." }];

export const UserNameAlertSubTitle = [{ text: "Print the basic sweet-alert" }];

export const SuccessMessageSubTitle = [{ text: "Print the success message." }];

export const DangerAlertSubTitle = [{ text: "Print the danger message." }];

export const WarningModeSubTitle = [{ text: "Print the warning message" }];

export const AutoCloseAlertSubTitle = [{ text: "A text message with an automatic timer" }];

export const MovieAlertSubTitle = [{ text: "Give the movie name & return value." }];
